module.exports = __webpack_public_path__ + "img/error-icon.482cff57.svg";